<template>
    <div class="warmup-task">

        <el-row :gutter="20">
            <el-col :span="showTaskList || isAddDanmuHandle ? 12 : 24">
                <div style="display:flex; gap: 12px; align-items:center;">
                    <!-- <el-input v-model="query.category_id" placeholder="分类ID category_id" style="width:200px" /> -->
                    <el-select v-model="query.category_id" clearable>
                        <el-option v-for="(value, key) in classifyList" :key="key" :value="value.id"
                            :label="value.name"></el-option>
                    </el-select>
                    <el-button type="primary" @click="loadDanmuList">刷新弹幕列表</el-button>
                    <el-button type="success" :disabled="showTaskList" @click="isAddDanmuHandle = true">添加弹幕</el-button>
                </div>

                <el-table :data="danmuList" size="mini" style="margin-top:12px;" max-height="300px">
                    <el-table-column prop="id" label="序号" width="80" />
                    <el-table-column prop="message" label="弹幕内容" />
                    <el-table-column label="操作" width="160">
                        <template #default="{ row }">
                            <el-button size="mini" type="danger" @click="delDanmu(row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-divider content-position="left">创建暖场弹幕任务(立即执行)</el-divider>

                <el-form :model="createForm" label-width="100px" size="mini">
                    <el-form-item label="分类ID">
                        <el-select v-model="createForm.category_id">
                            <el-option v-for="(value, key) in classifyList" :key="key" :value="value.id"
                                :label="value.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="房间ID">
                        <el-input v-model.number="createForm.room_id" style="width:200px" disabled />
                    </el-form-item>
                    <el-form-item label="执行时间(N秒后)">
                        <el-input-number v-model="createForm.timer" :min="1" :max="3600" />
                    </el-form-item>
                    <el-form-item label="弹幕发送间隔(秒)">
                        <el-input-number v-model="createForm.sleep_time" :min="1" :max="3600" />
                    </el-form-item>
                    <el-form-item label="发送次数">
                        <el-input-number v-model="createForm.retry_count" :min="1" :max="999" />
                    </el-form-item>
                    <el-form-item label="发送顺序">
                        <el-switch v-model="createForm.task_list" active-text="随机" inactive-text="顺序" />
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="createTask">创建任务(立即发送)</el-button>
                        <el-button type="primary" :disabled="isAddDanmuHandle"
                            @click="showTaskList = true">查看任务列表</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="12" v-if="isAddDanmuHandle || showTaskList">
                <template v-if="isAddDanmuHandle">
                    <el-divider content-position="left">添加弹幕</el-divider>
                    <el-form label-width="100px" size="mini">
                        <el-form-item label="所属分类ID">
                            <el-select v-model="addDanmuForm.category_id">
                                <el-option v-for="(value, key) in classifyList" :key="key" :value="value.id"
                                    :label="value.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="弹幕分类名称">
                            <el-input v-model="addDanmuForm.category_title" />
                        </el-form-item>
                        <el-form-item label="弹幕">
                            <el-input type="textarea" v-model="createMessagesText" rows="20" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addDanmu">添加弹幕</el-button>
                            <el-button type="normal" @click="isAddDanmuHandle = false">关闭窗口</el-button>
                        </el-form-item>
                    </el-form>
                </template>
                <template v-if="showTaskList">
                    <el-divider content-position="left">任务列表</el-divider>
                    <el-table :data="taskList" size="mini" style="margin-top:12px;" max-height="300px"
                        v-loading="loading">
                        <el-table-column prop="category_id" label="弹幕分类" width="80">
                            <template scope="{row}">
                                {{ categoryName(row.category_id) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="retry_count" label="次数" />
                        <el-table-column prop="timer" label="创建N秒后执行" />
                        <el-table-column label="操作" width="160">
                            <template #default="{ row }">
                                <el-button size="mini"
                                    :type="row.status == 'wait' || row.status == 'progress' ? 'danger' : 'info'"
                                    :disabled="row.status !== 'wait' && row.status !== 'progress'"
                                    @click="cancelTask(row.task_id)">
                                    {{ row.status == 'wait' || row.status == 'progress' ?  '停止执行'  :'已结束'}}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button style="margin-top: 10px;" type="normal" @click="showTaskList = false">关闭窗口</el-button>
                </template>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import { danmuApi, GetGoodsClassify } from "@/api/index.js" // 你实际路径自己调整

export default {
    name: "WarmupTask",
    props: {
        roomId: [String, Number],
        appid: { type: Number, default: 1 }
    },
    data() {
        return {
            query: {
                category_id: ''
            },
            classifyList: [],
            danmuList: [],
            createForm: {
                appid: 1,
                category_id: '',
                room_id: "",
                timer: 5,
                retry_count: 10,
                sleep_time: 10,
                task_list: true,
            },
            createMessagesText: "",
            isAddDanmuHandle: false,
            addDanmuForm: {
                category_id: null,
                category_title: '弹幕分类名称',
            },
            taskList: [],
            showTaskList: false,
            loading: false
        }
    },
    watch: {
        roomId: {
            immediate: true,
            handler(v) {
                this.createForm.room_id = v
                if (v) this.loadTaskList()
            }
        },
        showTaskList: {
            immediate: true,
            handler(v) {
                if (v) this.loadTaskList()
            }
        }
    },
    mounted() {
        this.createForm.appid = this.appid
        // 默认加载
        this.loadDanmuList()
        this.loadClassifyList()
    },
    methods: {
        categoryName(val) {
            const item = this.classifyList.find(f => f.id === val)
            return item ? item.name : ''
        },
        async loadDanmuList() {
            try {
                const category_id = this.query.category_id
                const res = await danmuApi.warmupDanmuList(category_id, this.appid)
                // 这里根据你的真实返回结构调整
                this.danmuList = res?.data || res || []
            } catch (e) {
                this.$message.error("弹幕列表加载失败")
                console.error(e)
            }
        },
        async loadTaskList() {
            this.loading = true
            try {
                const res = await danmuApi.warmupDanmuTaskList(this.roomId)
                // 这里根据你的真实返回结构调整
                this.taskList = res?.data.data
            } catch (e) {
                this.$message.error("任务列表加载失败")
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        async loadClassifyList() {
            try {
                let { data: classifyList } = await GetGoodsClassify()
                this.classifyList = classifyList
                if (this.classifyList) {
                    this.query.category_id = this.classifyList[0].id
                    this.createForm.category_id = this.classifyList[0].id
                }
            } catch (e) {
                this.$message.error("商品分类列表加载失败")
                console.error(e)
            }
        },
        splitMessages(text) {
            return (text || "")
                .split("\n")
                .map(s => s.trim())
                .filter(Boolean)
        },

        async createTask() {
            try {
                const payload = {
                    ...this.createForm,
                    task_list: this.createForm.task_list ? 1 : 0
                }
                await danmuApi.warmupDanmuTaskCreate(payload)
                this.$message.success("创建成功")
                this.loadTaskList()
            } catch (e) {
                this.$message.error("创建失败")
                console.error(e)
            }
        },

        async delDanmu(id) {
            try {
                await this.$confirm("确定删除这条？", "提示", { type: "warning" })
                await danmuApi.warmupDanmuDel(id)
                this.$message.success("删除成功")
                this.loadDanmuList()
            } catch (e) {
                if (e !== "cancel") console.error(e)
            }
        },

        async cancelTask(id) {
            try {
                await danmuApi.warmupDanmuTaskCancel(id)
                this.$message.success("已停止")
                this.loadTaskList()
            } catch (e) {
                if (e !== "cancel") console.error(e)
            }
        },

        async addDanmu() {
            try {
                const messages = this.splitMessages(this.createMessagesText)
                if (!messages.length) {
                    return this.$message.warning("请填写话术（每行一条）")
                }

                const danmuData = {
                    "message": messages,
                    "category_id": this.addDanmuForm.category_id,
                    "category_title": this.addDanmuForm.category_title,
                    "appid": 1
                }
                await danmuApi.warmupDanmuAdd(danmuData)
                this.$message.success("分类弹幕已添加")
                this.loadDanmuList()
            } catch (e) {
                this.$message.error("分类弹幕添加失败")
                console.error(e)
            } finally {
                this.isAddDanmuHandle = false
            }
        }
    }
}
</script>
